/**
 * SiteModal
 * @description Sitewide modal component
 * @see src/templates/_partials/siteModal.twig
 * @param debug
 *
 * @return Alpine
 */

import Alpine from 'alpinejs'

export const SITE_MODAL = 'SiteModal'

export default ({
  debug = window?.APP?.CONFIG?.DEBUG || false,
}) => {
  return {
    // $dialog - magic property for Alpine Dialog
    debug,
    nextAction: () => {},
    showCloseButton: true,
    isDialogOpen: false, // used for x-model on the dialog
    init() {
      if (this.debug) {
        console.log('[SiteModal] initialized')
      }
      this.reset()
      this.register()
    },
    setNextAction(action) {
      this.nextAction = action
    },
    reset() {
      this.showCloseButton = true
      this.isDialogOpen = false
      this.resetNextAction()
    },
    resetNextAction() {
      this.nextAction = () => {
        if (this.debug) {
          console.log('[SiteModal] No action set for modal')
        }
      }
    },
    setContent(content) {
      this.$refs.dialogContent.replaceChildren(content)
    },
    register() {
      Alpine.store(SITE_MODAL, this)
    },
  }
}
